// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__lrZRq","active":"Modal_active__G7CdN","modalContent":"Modal_modalContent__2Ple8"};